export default __webpack_public_path__ + "static/media/b_g.6936d560.jpeg";